// @flow
import * as React from "react";
import type { InputField } from "types/input-field";

import { TriggerUserActions } from "@/components/TriggerUserActions";

import TextInput from "./TextInput";

export type Props = {
  disabled?: boolean,
  fontSize?: number,
  innerRef: any,
  inputField: InputField,
  onChange: (event: SyntheticEvent<HTMLInputElement>) => void | Promise<void>,
  onFocus: () => void,
  setVariableHeight?: (height: number) => void,
  value?: ?string,
  variableHeight?: number,
};

function NameInput({
  disabled,
  fontSize,
  innerRef,
  inputField,
  onChange,
  onFocus,
  setVariableHeight,
  value,
  variableHeight,
  ...props
}: Props): React.Node {
  return (
    <TriggerUserActions>
      <TextInput
        disabled={disabled}
        fontSize={fontSize}
        innerRef={innerRef}
        inputField={inputField}
        onChange={onChange}
        onFocus={onFocus}
        placeholder="Full Name"
        setVariableHeight={setVariableHeight}
        value={value}
        variableHeight={variableHeight}
        viewValue="Full Name"
        {...props}
      />
    </TriggerUserActions>
  );
}

export default NameInput;
